export default __webpack_public_path__ + "static/media/ExpireAtricle.deb77233.svg";